import { saveAs } from "file-saver";

export const fileSave = (url: string, name: string) => {
  return fetch(url)
    .then((res) => res.blob())
    .then((blob) => saveAs(blob, name));
};
